var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.182,
    height: 20.181,
    viewBox: "0 0 20.182 20.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.055)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149.619,4.093a2.355,2.355,0,1,0-3.166,0A3.031,3.031,0,0,0,144,7.064V8.409a.336.336,0,0,0,.336.336h7.4a.336.336,0,0,0,.336-.336V7.064A3.031,3.031,0,0,0,149.619,4.093Zm-3.265-1.738a1.682,1.682,0,1,1,1.682,1.682A1.684,1.684,0,0,1,146.355,2.355ZM151.4,8.073h-6.727V7.064a2.357,2.357,0,0,1,2.355-2.355h2.018A2.357,2.357,0,0,1,151.4,7.064Z",
    transform: "translate(-144)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.436)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.619,276.093a2.355,2.355,0,1,0-3.166,0A3.031,3.031,0,0,0,0,279.064v1.345a.336.336,0,0,0,.336.336h7.4a.336.336,0,0,0,.336-.336v-1.345A3.031,3.031,0,0,0,5.619,276.093Zm-3.265-1.738a1.682,1.682,0,1,1,1.682,1.682A1.684,1.684,0,0,1,2.355,274.355ZM7.4,280.073H.673v-1.009a2.357,2.357,0,0,1,2.355-2.355H5.045A2.357,2.357,0,0,1,7.4,279.064Z",
    transform: "translate(0 -272)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.109 11.436)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M293.619,276.093a2.355,2.355,0,1,0-3.166,0A3.031,3.031,0,0,0,288,279.064v1.345a.336.336,0,0,0,.336.336h7.4a.336.336,0,0,0,.336-.336v-1.345A3.031,3.031,0,0,0,293.619,276.093Zm-3.265-1.738a1.682,1.682,0,1,1,1.682,1.682A1.684,1.684,0,0,1,290.355,274.355Zm5.045,5.718h-6.727v-1.009a2.357,2.357,0,0,1,2.355-2.355h2.018a2.357,2.357,0,0,1,2.355,2.355Z",
    transform: "translate(-288 -272)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.352 10.752)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.84,255.744l-.672.026c.009.232.028.467.055.7l.668-.08C32.866,256.175,32.848,255.958,32.84,255.744Z",
    transform: "translate(-32.168 -255.744)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.352 9.383)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.223,223.176c-.027.229-.046.464-.055.7l.672.026c.008-.215.026-.432.051-.644Z",
    transform: "translate(-32.168 -223.176)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.25 3.471)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M101.627,82.544c-.184.14-.365.29-.539.446l.45.5c.16-.144.327-.283.5-.412Z",
    transform: "translate(-101.088 -82.544)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.902 6.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.528,159.44c-.1.21-.19.427-.272.645l.63.236c.076-.2.16-.4.251-.594Z",
    transform: "translate(-45.256 -159.44)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.518 8.014)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.253,190.584c-.064.222-.119.451-.165.679l.66.133c.042-.21.094-.421.153-.627Z",
    transform: "translate(-36.088 -190.584)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.289 4.406)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M78.669,104.776c-.161.17-.316.346-.461.525l.523.423c.134-.165.277-.329.426-.485Z",
    transform: "translate(-78.208 -104.776)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.361 2.715)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M128.115,64.568c-.2.109-.406.228-.6.355l.365.566c.182-.117.369-.227.556-.327Z",
    transform: "translate(-127.512 -64.568)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.498 5.49)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59.8,130.6c-.132.192-.257.391-.372.593l.584.334c.106-.186.222-.37.343-.547Z",
    transform: "translate(-59.424 -130.6)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.363 18.342)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M199.069,436.256l-.133.66c.226.046.459.082.692.11l.078-.668C199.492,436.332,199.277,436.3,199.069,436.256Z",
    transform: "translate(-198.936 -436.256)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.068 18.338)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M263.878,436.16c-.209.042-.423.077-.638.1l.081.668c.232-.028.464-.066.69-.112Z",
    transform: "translate(-263.24 -436.16)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.752 18.492)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M232.624,439.84c-.215.008-.432.009-.646,0l-.027.672c.112,0,.225.007.339.007s.24,0,.36-.008Z",
    transform: "translate(-231.952 -439.84)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.482 3.92)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M368.705,93.224l-.449.5c.16.144.315.3.462.45l.488-.462C369.047,93.544,368.879,93.38,368.705,93.224Z",
    transform: "translate(-368.256 -93.224)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.371 4.934)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M389.907,117.32l-.523.423c.134.166.264.34.386.518l.555-.38C390.193,117.689,390.052,117.5,389.907,117.32Z",
    transform: "translate(-389.384 -117.32)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.156 10.082)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M432.52,239.776l-.672.026c0,.106.006.213.006.32s0,.218-.006.327l.672.026q.007-.176.007-.354C432.527,240.006,432.525,239.89,432.52,239.776Z",
    transform: "translate(-431.848 -239.776)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.102 6.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M407.3,144.736l-.584.335c.107.186.207.379.3.572l.608-.287C407.528,145.146,407.419,144.937,407.3,144.736Z",
    transform: "translate(-406.72 -144.736)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.65 7.35)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M420.414,174.816l-.63.237c.075.2.143.407.2.613l.647-.185C420.569,175.257,420.5,175.033,420.414,174.816Z",
    transform: "translate(-419.784 -174.816)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.004 8.693)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M428.883,206.776l-.659.133c.042.211.077.425.1.638l.668-.079C428.966,207.237,428.929,207,428.883,206.776Z",
    transform: "translate(-428.224 -206.776)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.459 3.07)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M344.236,73.04l-.364.566c.18.116.357.24.528.371l.408-.535C344.623,73.3,344.431,73.165,344.236,73.04Z",
    transform: "translate(-343.872 -73.04)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.32 2.41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M317.093,57.328l-.269.616c.2.086.391.181.581.282l.318-.593C317.518,57.523,317.306,57.42,317.093,57.328Z",
    transform: "translate(-316.824 -57.328)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNetwork);
export default __webpack_public_path__ + "static/media/ico-network.2c315604357f811fbb5d11d5998358c8.svg";
export { ForwardRef as ReactComponent };